import React from "react";
import { Button, Grid } from "@mui/material";
// import { useNavigate } from "react-router-dom";
import Top from "../../Top";
import Left from "../../Left";
import defaultProfilePic from "../../../assets/Images/avtarPic.png";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import {
  makePostRequest,
  uploadFileRequest,
} from "../../../utils/utils";
import swal from "sweetalert";

// const label = { inputProps: { "aria-label": "Switch demo" } };

function ServiceTypePage() {
  // const navigate = useNavigate();
  const [showLoader, setShowLoader] = React.useState(false);
  const [profile_pic, setProfilePic] = React.useState("");
  const [serviceType, setServiceType] = React.useState("");
  const [sortBy] = React.useState("");
  const [status] = React.useState();
  const [q] = React.useState("");
  const [isEditServiceType] = React.useState(false);
  const [editServiceTypeId] = React.useState();

  const [profileErrMsg, setProfileErrMsg] = React.useState("");
  const [serviceNameErrMsg, setServiceNameErrMsg] = React.useState("");
  const [serviceTypeList, setServiceTypeList] = React.useState([]);
  const [Upload] = React.useState(false);

  async function validateImage(fileData) {
    if (fileData.name.match(/.(jpg|JPG|jpeg|JPEG|png|PNG|gif|GIF)$/i))
      return true;
    else return false;
  }

  async function uploadImageOrFile(fileData) {
    const formData = new FormData();
    formData.append("image", fileData);
    var fileUrl;
    setShowLoader(true);
    await uploadFileRequest("guards/uploadImages", formData).then(
      (response) => {
        fileUrl = response.data.imagepath[0].location;
      }
    );
    setShowLoader(false);

    return fileUrl;
  }

  async function uploadProfilePic(e) {

    setProfileErrMsg("")
    const file = e.target.files[0];
    if (await validateImage(file)) {
      var profilePicUrl = await uploadImageOrFile(file);
      setProfilePic(profilePicUrl);
    }
    else
      setProfileErrMsg("Invalid File Format");
  }

  // add Service Type
  async function saveServiceType() {
    if (serviceType) {
      let isDuplicateName;
      setShowLoader(true);
      await makePostRequest("servicetype/getbyname", {serviceTypeName:serviceType})
        .then((response) => {
          if (response.data.data !== undefined) {
              console.log(response.data.data);
              if(isEditServiceType==true)
                isDuplicateName=false;
              else
                isDuplicateName=true;
          } 
          setShowLoader(false);
        })
        .catch((err) => {
          console.log(err);
          setShowLoader(false);
          swal("There was an error!", "more error details", "warning");
        });

    if(isDuplicateName==true)
    {
      setServiceNameErrMsg("Duplicate Name");
    }
    else
    {
    if(isEditServiceType)
    {
      setShowLoader(true);
      let inputdata = {
        service_type_id:editServiceTypeId,
        profile_pic: profile_pic,
        service_name: serviceType,
        
      };

      await makePostRequest("servicetype/update", inputdata)
        .then((response) => {
          if (response.data.data !== undefined) {
            swal("Success", "ServiceType Updated Successfully", "success", {
              timer: 2000,
              buttons: false,
            });
            // window.location.reload();
            GetServiceTypeList();
          } 
          setShowLoader(false);
        })
        .catch((err) => {
          console.log(err);
          setShowLoader(false);
          swal("There was an error!", "more error details", "warning");
        });


      setProfileErrMsg("");
      
    }
    else
    {
      setShowLoader(true);
      
     
      let inputdata = {
        profile_pic: profile_pic,
        service_name: serviceType,
        status: true
      };

      await makePostRequest("servicetype/insert", inputdata)
        .then((response) => {
          if (response.data.data !== undefined) {
            swal("Success", "ServiceType Added Successfully", "success", {
              timer: 2000,
              buttons: false,
            });
            // window.location.reload();
            GetServiceTypeList();
            setServiceType("");
            setProfilePic("");
          } 
          setShowLoader(false);
        })
        .catch((err) => {
          console.log(err);
          setShowLoader(false);
          swal("There was an error!", "more error details", "warning");
        });


      setProfileErrMsg("");
    }
    setServiceNameErrMsg("");
    }
    }
    else
    setServiceNameErrMsg('Required')

  }

   // add Service Type
   async function updateStatus(status,serviceTypeId) {
      setShowLoader(true);
     let inputdata = {
        service_type_id:serviceTypeId,
        status: status
      };

      await makePostRequest("servicetype/update", inputdata)
        .then((response) => {
          if (response.data.data !== undefined) {
            // window.location.reload();
            GetServiceTypeList();
          } 
          setShowLoader(false);
        })
        .catch((err) => {
          console.log(err);
          swal("There was an error!", "more error details", "warning");
          setShowLoader(false);
        });


      setProfileErrMsg("");
    

  }

  // Get Service Type List
  async function GetServiceTypeList() {


    let inputdata = {
      status: status,
      sortBy: sortBy,
      searchString: q
    };

    await makePostRequest("servicetype/getalllisting", inputdata)
      .then((response) => {
        if (response.data.data !== undefined) {
          console.log(response.data.data.rows);
          setServiceTypeList(response.data.data.rows);
        } else {
        }
      })
      .catch((err) => {
        console.log(err);
        swal("There was an error!", "more error details", "warning");
      });

  }

  React.useEffect(() => {
    GetServiceTypeList();
  }, [q, Upload]);

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">Service Type</h1>
          </Grid>
          <Grid item xs={12} md={12}>
            <div className="residentHeading">Add Service Type</div>

            <div className="addAgencyMain">
              <div className="addServiceTypeMain">
                <Grid container spacing={3}>

                  <Grid item xs={12} md={12}>
                    <div className="uploadImDiv">
                      <div className="uploadIm">
                        {profile_pic ? (
                          <img src={profile_pic} />
                        ) : (
                          <img src={defaultProfilePic} />
                        )}
                      </div>
                      <div className="uploadInpu">
                        <FileUploadIcon />
                        <span>Upload Profile Photo</span>
                        <em className="uploadPhotoErrorMsg">{profileErrMsg}</em>
                        <input
                          type="file"
                          id="profile_pic"
                          onChange={(event) => uploadProfilePic(event)}
                        />
                      </div>
                    </div>
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <label className="tabsLabel" >Service Type</label>
                    <input className="inputSt" placeholder="Service Type" value={serviceType} onChange={(e) => setServiceType(e.target.value)} />
                        <p>{serviceNameErrMsg}</p>
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <Button className="addBt servAdd" onClick={saveServiceType}>Add</Button>
                  </Grid>


                  <Grid item xs={12} md={12}>
                    {serviceTypeList ?
                      <>
                        {serviceTypeList.map((option) => (
                          <div className="visitContDiv">
                            <div className="visitCont1 resideNewContOut">
                              <div className="visitContProf">
                                {option.profile_pic ? (
                                  <img src={option.profile_pic} />
                                ) : (
                                  <img src={defaultProfilePic} />
                                )}
                              </div>
                              <div className="visitContLeft">
                                <h3 className="visitContHed">Service Type Name</h3>
                                <p className="visitContMob">{option.service_name}</p>
                              </div>
                              <div className="visitBottCont">
                                <p>Active / Deactive</p>
                                <div className="serviceTypSwitchMain">
                                  {option.status==true?
                                  <FormControlLabel 
                                    control={<Switch checked onClick={()=>updateStatus('false',option.service_type_id)}/>} 
                                  />
                                  :
                                  <FormControlLabel
                                    control={<Switch onClick={()=>updateStatus('true',option.service_type_id)} />}
                                  />}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </>
                      :
                      <>No Service Type Added</>
                    }

                  </Grid>

                </Grid>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>

      {showLoader ? (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      ) : (
        <></>
      )}

    </>
  );
}

export default ServiceTypePage;
